const nextElementSelector = '.js-header-wrapper';
let nextElement = document.querySelector(nextElementSelector);
const legacyElementSelector = '#header-container';
let legacyElement = document.querySelector(legacyElementSelector);
const sdlHeaderElementSelector = '.js-header-global';
let sdlHeaderElement = document.querySelector(sdlHeaderElementSelector);


export const getHeaderElement = () => {
  sdlHeaderElement = sdlHeaderElement || document.querySelector(sdlHeaderElementSelector);

  if (sdlHeaderElement) {
    return sdlHeaderElement;
  }

  nextElement = nextElement || document.querySelector(nextElementSelector);

  if (nextElement) {
    return nextElement;
  }

  legacyElement = legacyElement || document.querySelector(legacyElementSelector);

  return legacyElement;
};

export const getHeaderContainerElement = () => {
  sdlHeaderElement = sdlHeaderElement || document.querySelector(sdlHeaderElementSelector);

  if (sdlHeaderElement) {
    return sdlHeaderElement.querySelector('.js-header');
  }

  return getHeaderElement();
};

export const getHeaderElementSelector = () => {
  sdlHeaderElement = sdlHeaderElement || document.querySelector(sdlHeaderElementSelector);

  if (sdlHeaderElement) {
    return sdlHeaderElementSelector;
  }

  nextElement = nextElement || document.querySelector(nextElementSelector);

  if (nextElement) {
    return nextElementSelector;
  }

  legacyElement = legacyElement || document.querySelector(legacyElementSelector);

  return legacyElementSelector;
};